<template>
	<div class="coupon-list-item">
		<div class="label">
			<div class="label-desc"><span>{{ info.name }}</span></div>
			<span class="label-warning" v-if="info.leftDays">剩余{{ info.leftDays }}天</span>
		</div>
		<div class="content">
			<div class="content-l">
				<template>
					<div class="content-l-price" v-if="info.type === 1"><span class="price-mark">¥</span><span class="price">{{ info.discount }}</span></div>
          <div class="content-l-price" v-else><span class="price">{{ info.discount }}</span><span class="price-discount">折</span></div>
				</template>
				<div class="content-l-desc">
					<p>满{{ info.needOverAmount }}可用</p>
					<p class="sub-title">有效期至{{ info.endTime ? info.endTime.substr(0,16) : ''}}</p>
				</div>
			</div>
			<div class="content-r">
				<span class="coupon-button coupon-button-blue" :class="{'disabled': disabled}" @click="useCoupon">使用</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { deepCopy } from '../../../utils';

	export default {
		name: 'couponListItem',
		props: {
			info: {
				type: Object,
				default: ()=>{
					return {
					}
				}
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			useCoupon() {
				if(this.disabled) return;
				this.$emit('useCoupon', deepCopy(this.info))
			},
		}
	};
</script>

<style lang="less" scoped>
	.coupon-list-item {
		height: 120px;
		margin:20px;
		position: relative;
		background:rgba(255,255,255,1);
		box-shadow:0px 0px 20px 0px rgba(0,0,0,0.05);
		border-radius:5px;
		.label {
			position: absolute;
			top: 0;
			left: 0;
			display: flex;
			.label-desc {
				border-radius:5px 0px 5px 0px;
				background:linear-gradient(90deg,rgba(242,218,178,1) 0%,rgba(217,181,123,1) 100%);
				> span {
					display: inline-block;
					font-size: 12px;
					height: 27px;
					line-height: 27px;
					padding: 0px 10px;
					color: #7C561E;
				}
			}
			.label-warning {
				display: inline-block;
				margin-left: 10px;
				color: #FA5741;
				font-size: 12px;
				line-height: 27px;
			}
		}
		.content {
			display: flex;
			height: 100%;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px 0 0;
			&-l {
				display: flex;
				justify-content: space-between;
				align-items: flex-end;
				margin-top: 15px;
				.content-l-price {
					width: 82px;
					height: 100%;
					font-family: DINCondensedBold;
					color: rgba(250, 87, 65, 1);
					display: flex;
					align-items: flex-end;
					justify-content: center;
					.price-mark {
						font-size: 20px;
						line-height: .7;
					}
					.price-discount {
						font-size: 20px;
						line-height: .9;
					}
					.price{
						font-size: 38px;
						line-height: .5;
					}
				}
				.content-l-desc {
					margin-left: 10px;
					display: flex;
					flex-direction: column;
					.sub-title {
						margin-top: 10px;
					}
				}
			}
		}

	}
</style>
